import { render } from "./BaseDropdown.vue?vue&type=template&id=3f724a3b"
import script from "./BaseDropdown.vue?vue&type=script&lang=js"
export * from "./BaseDropdown.vue?vue&type=script&lang=js"
script.render = render

export default script